import { router } from '@inertiajs/react'
import { ReportsList } from '@/components/reports/ReportsList'
import type { Report, PaginationInfo, ReportFilterParams } from '@/components/reports/types'

interface Stream {
  id: string
  name: string
}

interface Props {
  reports: Report[]
  streams: Stream[]
  pagination: PaginationInfo
}

// Build URL with filter params
function buildUrl(path: string, filters: ReportFilterParams, page?: number) {
  const params = new URLSearchParams()
  if (page && page > 1) params.set('page', String(page))
  if (filters.streamId) params.set('stream', filters.streamId)
  if (filters.dateFrom) params.set('from', filters.dateFrom)
  if (filters.dateTo) params.set('to', filters.dateTo)
  if (filters.search) params.set('q', filters.search)

  const queryString = params.toString()
  return queryString ? `${path}?${queryString}` : path
}

export default function ReportsIndex({ reports, streams, pagination }: Props) {
  const handleView = (id: string) => {
    router.visit(`/reports/${id}`)
  }

  const handleSendEmail = async (id: string) => {
    if (!confirm('Send this report to all stream subscribers?')) {
      return
    }

    try {
      const response = await fetch(`/reports/${id}/send_email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      })

      const data = await response.json()

      if (response.ok) {
        alert(data.message)
        router.reload()
      } else {
        alert(data.error || 'Failed to send email')
      }
    } catch (error) {
      alert('Failed to send email')
    }
  }

  const handleViewItems = (id: string) => {
    router.visit(`/items?report_id=${id}`)
  }

  const handleDelete = (id: string) => {
    if (confirm('Are you sure you want to delete this report?')) {
      router.delete(`/reports/${id}`)
    }
  }

  const handlePageChange = (page: number, filters: ReportFilterParams) => {
    router.visit(buildUrl('/reports', filters, page), { preserveScroll: true })
  }

  const handleFilterChange = (filters: ReportFilterParams) => {
    router.visit(buildUrl('/reports', filters), { preserveScroll: true })
  }

  return (
    <ReportsList
      reports={reports}
      streams={streams}
      pagination={pagination}
      onView={handleView}
      onSendEmail={handleSendEmail}
      onViewItems={handleViewItems}
      onDelete={handleDelete}
      onPageChange={handlePageChange}
      onFilterChange={handleFilterChange}
    />
  )
}
